/**
 * Paths the `wandb` CLI opens. Forge serves them without the shell header; the
 * W&B app serves them itself (`frontends/app/src/routes/auth/authPaths.ts`).
 */
export const CLI_LOGIN_PATH = '/cli-login';
export const CLI_LOGIN_SUCCESS_PATH = '/cli-login-success';
export const CLI_LOGIN_CANCELED_PATH = '/cli-login-canceled';

export const CLI_LOGIN_PATHS: readonly string[] = [
  CLI_LOGIN_PATH,
  CLI_LOGIN_SUCCESS_PATH,
  CLI_LOGIN_CANCELED_PATH,
];
